/** @format */

import React from 'react';

import { BENEFITS } from './constants';

import './style.scss';

export default function BenefitsBar() {
	return (
		<div className="ph-benefits-bar-wrapper">
			<div className="ph-benefits-bar-container">
				{BENEFITS.map((benefit) => (
					<div className="ph-benefits-bar-cell" key={benefit.id}>
						<div className="ph-benefits-bar-item" data-testid="ph-benefits-bar-item">
							<img className="ph-benefits-bar-icon" src={benefit.image} alt="" />
							<div className="ph-benefits-bar-text">
								<p className="ph-benefits-bar-title">{benefit.title}</p>
								<p className="ph-benefits-bar-subtitle">{benefit.subtitle}</p>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}
